import React from "react";
import '../custom frames/frame-style.scss'
import useLocalizedNavigate from "../../hooks/useLocalizedNavigate";

const FrameContentBottom = ({ style, title, message, subtitle, buttonTitle, bottom, buttonLink }) => {

    const navigate = useLocalizedNavigate();
    const handleLogo = () => {
        if (typeof buttonLink === 'string' && buttonLink.startsWith('/')) {
            navigate(buttonLink, { state: { id: 1, name: 'sabaoon' } });
        } else {
            window.location.replace(buttonLink);
        }


    };
    return (
        <div className={style}>
            <div className='title-content'>{title}</div>
            <div className='message-content'>{message}</div>
            <button id='btnDonate' className='noBorder' onClick={handleLogo}>{buttonTitle}</button>
            <div className='subtitle-content'>{subtitle}</div>
            <div className='bottom-content'>{bottom}</div>
        </div>
    );
}


export default FrameContentBottom;